<template>
  <div>
    <!-- <userPop v-if="userPopShow" @changeShowLogin="closeUserPop" :userPopShow="true" :righttop="userPopTitle"></userPop> -->
    <infUserPop v-if="userPopShow" @changeShowLogin="closeUserPop" :userPopShow="true" :righttop="userPopTitle">
    </infUserPop>

    <register v-if="registerShow" @closeRegister="closeRegister" @loginPop="loginPop"></register>

    <login v-if="loginShow" @closeLogin="closeLogin" @registerPop="registerPop"></login>

    <!-- Heaader -->
    <TopBar :userDetails="userinfo" :logo="siteLogo" :showMoney="showMoney" />

    <div class="middle">
      <router-view></router-view>
    </div>

    <div class="footer-menu">
      <div class="menu">
        <router-link to="/"><img :style="$route.path === '/' ? { width: '70px' } : { width: '35px' }" :src="$route.path === '/'
            ? require('@/static/images/icon-home-active.png')
            : require('@/static/images/icon-home.png')
          " />
          <p v-if="$route.path !== '/'" style="padding-right: 0px; display: flex; flex-direction: column; gap: 2px;">
            <span style="margin-top: 0.5rem;">{{ $t('home') }}</span>
          </p>
        </router-link>
      </div>
      <div class="menu">
        <router-link :to="{ name: 'promotion-activity' }"><img :style="$route.path === '/promotion/activity'
            ? { width: '70px' }
            : { width: '35px' }
          " :src="$route.path === '/promotion/activity'
                ? require('@/static/images/icon-promo-active.png')
                : require('@/static/images/icon-promo.png')
              " />
          <p v-if="$route.path !== '/promotion/activity'" style="display: flex; flex-direction: column; gap: 2px;">
            <!-- <span style="color: #fff; font-size: 20px; font-weight: 700;">.</span> -->
            <span style="margin-top: 0.5rem;">{{ $t('promotion') }}</span>
          </p>
        </router-link>
      </div>
      <div class="menu">
        <router-link :to="{ name: 'recharge' }"><img :style="$route.path === '/recharge'
            ? { width: '70px' }
            : { width: '35px' }
          " :src="$route.path === '/recharge'
                ? require('@/static/images/icon-deposit-active.png')
                : require('@/static/images/icon-deposit.png')
              " />
          <p v-if="$route.path !== '/recharge'" style="display: flex; flex-direction: column; gap: 2px;">
            <!-- <span style="color: #fff; font-size: 20px; font-weight: 700;">.</span> -->
            <span style="margin-top: 0.5rem;">{{ $t('deposit') }}</span>
          </p>
        </router-link>
      </div>
      <div class="menu">
        <router-link :to="{ name: 'withdraw' }"><img :style="$route.path === '/withdraw'
            ? { width: '70px' }
            : { width: '30px' }
          " :src="$route.path === '/withdraw'
                ? require('@/static/images/icon-withdraw-active.png')
                : require('@/static/images/icon-withdraw.png')
              " />
          <p v-if="$route.path !== '/withdraw'" style="display: flex; flex-direction: column; gap: 2px;">
            <!-- <span style="color: #fff; font-size: 20px; font-weight: 700;">.</span> -->
            <span style="margin-top: 0.5rem;">{{ $t('withdraw') }}</span>
          </p>
        </router-link>
      </div>
      <div class="menu">
        <router-link :to="'/profile'"><img :style="$route.path === '/profile' ? { width: '70px' } : { width: '35px' }
          " :src="$route.path === '/profile'
                ? require('@/static/images/icon-profile-active.png')
                : require('@/static/images/icon-profile.png')
              " />
          <p v-if="$route.path !== '/profile'" style="display: flex; flex-direction: column; gap: 2px;">
            <!-- <span style="color: #fff; font-size: 20px; font-weight: 700;">.</span> -->
            <span style="margin-top: 0.5rem;">{{ $t('profile') }}</span>
          </p>
        </router-link>
      </div>
    </div>

    <!-- Login Modal -->
    <div class="modal fade loginReg loginModal" :class="{ show: showModalLogin }" tabindex="-1"
      aria-labelledby="loginModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <div
              style="display: flex; align-items: center; justify-content: space-between; width: 100%; margin-bottom: 2rem;">
              <p @click="showRegisterModal()" style="color: #233847 !important; margin-left: 2.5rem; margin-top: 0rem; cursor: pointer;">{{ $t('sign-up') }}</p>
              <p style="color: #fff !important; margin-right: 0.5rem;">{{ $t('member-login') }}</p>
            </div>
          </div>
          <div>
            <div class="modal-body">
              <h2 class="modal-title text-uppercase">{{ $t('sign-in-message') }}</h2>
              <div class="form-content">
                <form class="demo-ruleForm" ref="loginForm" @submit.prevent="subLogin">
                  <div class="input-group mb-3 golden-ring-border" style="border: 10px !important;">
                    <vue-country-code :defaultCountry="'br'" :disabledFetchingCountry="true" ref="vcc"
                      :enabledCountryCode="true" :onlyCountries="['br']" @onSelect="onSelectLogin">
                    </vue-country-code>
                    <input type="text" class="form-control" placeholder="000 000 0000" aria-label="Phone number"
                      aria-describedby="phone" v-model="formLabelAlign.name" />
                    <small class="text-danger" v-if="validationErrors.name">{{
                      validationErrors.name
                    }}</small>
                  </div>
                  <div class="d-flex golden-ring-border" style="position: relative">
                    <input :type="showPassword ? 'text' : 'password'" class="form-control" :placeholder="$t('password')"
                      v-model="formLabelAlign.password" @blur="validatePassword" />
                    <img v-if="showPassword" @click="showPasswordFunc()" loading="lazy"
                      src="@/static/images/security/eye.svg" class="password-icon" width="30px" height="30px" alt="" />
                    <img v-else @click="showPasswordFunc()" loading="lazy" src="@/static/images/security/eye-off.svg"
                      class="password-icon" width="30px" height="30px" alt="" />
                  </div>
                  <small class="text-danger" v-if="validationErrors.password">{{
                    validationErrors.password
                  }}</small>

                  <div class="row mt-3">
                    <div class="col-6">
                      <div class="form-check">
                        <input class="form-check-input golden-ring-border" type="checkbox" value="" id="remember" />
                        <label class="form-check-label" for="remember" style="font-weight: 600; color: #fff;">{{
                          $t('remember-me')
                        }}</label>
                      </div>
                    </div>
                  </div>

                  <button class="btn btn-login w-100 mt-2" type="submit">
                    {{ $t('sign-in') }}
                  </button>
                  <div class="mt-4 mb-4" style="display: flex; align-items: center; justify-content: space-around">
                    <label @click="closeLoginModal()"><router-link to="/information-center/support">{{
                      $t('Support')
                    }}</router-link></label>
                    <label @click="closeLoginModal()"><router-link to="/information-center/support">{{
                      $t('forgot-password')
                    }}</router-link></label>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: center; align-items: center; cursor: pointer; margin-bottom: -4rem;" class="">
            <img
              src="@/static/images/close.png"
              class="closeModal"
              @click="closeLoginModal()"
              width="15%"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Register Modal -->
    <div class="modal fade loginReg regModal" :class="{ show: showModalRegister }" tabindex="-1"
      aria-labelledby="regsiterModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <div
              style="display: flex; align-items: center; justify-content: space-between; width: 100%; margin-bottom: 2rem;">
              <p  style="color: #fff !important; font-weight: 700; margin-left: 3rem;">{{ $t('sign-up') }}</p>
              <p @click="showLoginModal()" style="color: #233847 !important; margin-right: 0.5rem; cursor: pointer;">{{ $t('member-login') }}</p>
            </div>
          </div>

          <div class="register-bg">
            <div class="modal-body">
              <h2 class="modal-title text-uppercase">{{ $t('register') }}</h2>
              <div class="form-content">
                <form ref="registForm" class="demo-ruleForm">
                  <div class="input-group mb-3 golden-ring-border" style="border: 10px !important;">
                    <vue-country-code :defaultCountry="'br'" :disabledFetchingCountry="true" ref="vcc"
                      :enabledCountryCode="true" :onlyCountries="['br']" @onSelect="onSelect">
                    </vue-country-code>
                    <input type="text" class="form-control" placeholder="000 000 0000" v-model="registData.phone"
                      @input="formatNumber" maxlength="13" />
                  </div>
                  <small class="text-danger" v-if="validationErrors.phone">{{
                    validationErrors.phone
                  }}</small>

                  <div class="mb-3">
                    <div class="d-flex golden-ring-border" style="position: relative">
                      <input :type="showPassword3 ? 'text' : 'password'" class="form-control" id=""
                        :placeholder="$t('password')" v-model="registData.password" />
                      <img v-if="showPassword3" @click="showPasswordFunc3()" loading="lazy"
                        src="@/static/images/security/eye.svg" class="password-icon" width="30px" height="30px"
                        alt="" />
                      <img v-else @click="showPasswordFunc3()" loading="lazy" src="@/static/images/security/eye-off.svg"
                        class="password-icon" width="30px" height="30px" alt="" />
                    </div>
                    <small class="text-danger" v-if="validationErrors.password">{{ validationErrors.password }}</small>
                  </div>

                  <div class="mb-3">
                    <div class="d-flex golden-ring-border" style="position: relative">
                      <input :type="showPassword2 ? 'text' : 'password'" class="form-control" id=""
                        :placeholder="$t('confirm-password')" v-model="registData.password_confirmation" />
                      <img v-if="showPassword2" @click="showPasswordFunc2()" loading="lazy"
                        src="@/static/images/security/eye.svg" class="password-icon" width="30px" height="30px"
                        alt="" />
                      <img v-else @click="showPasswordFunc2()" loading="lazy" src="@/static/images/security/eye-off.svg"
                        class="password-icon" width="30px" height="30px" alt="" />
                    </div>
                    <small class="text-danger" v-if="validationErrors.password_confirmation">{{
                      validationErrors.password_confirmation }}</small>
                  </div>

                  <div class="row mt-3">
                    <div>
                      <div class="form-check">
                        <input class="form-check-input golden-ring-border" type="checkbox" value="" id="remember" />
                        <label class="form-check-label" for="remember" style="font-weight: 600; color: #fff;">{{
                          $t('reg-agreement')
                        }}</label>
                      </div>
                    </div>
                    <div class="col-6 text-end">
                    </div>
                  </div>

                  <button class="btn btn-register w-100 mt-2" type="submit" @click.prevent="subRegist">
                    {{ $t('register') }}
                  </button>
                  <div class="mt-4" style="display: flex; align-items: center; justify-content: center">
                    <label @click="closeRegisterModal()"><router-link to="/information-center/support">{{
                      $t('Support')
                    }}</router-link></label>
                  </div>
                </form>
              </div>
            </div>
            <div style="display: flex; justify-content: center; align-items: center; cursor: pointer; margin-bottom: -4rem;">
              <img
                src="@/static/images/close.png"
                class="closeModal"
                @click="closeRegisterModal()"
                width="15%"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Customer Service Button
    <div class="customer-service" @click="showModal">
      <img src="@/static/images/icon/icon-cs.png"/>
      <p>{{ $t('MessageCenter') }}</p>
    </div> -->

    <!-- Modal Pop-up -->
    <div class="modal-pop" v-if="isModalVisible">
      <div class="cs-box">
        <div class="text-right">
          <router-link to="#" class="close" @click.prevent="hideModal"><i class="el-icon-close"></i></router-link>
        </div>

        <div class="info">
          <img src="@/static/images/cs-img.png" />
          <div>
            <h2><span>7/24</span> {{ $t('cs-title') }}</h2>
            <p>{{ $t('cs-text') }}</p>
          </div>
        </div>

        <div class="tele">
          <div class="d-flex">
            <img src="@/static/images/telegram.png" height="50" />
            <div style="margin-left: 20px">
              <h4>Telegram</h4>
              <p>@pos7248</p>
            </div>
          </div>
          <router-link to="https://t.me/pos7248" target="_blank" class="btn">{{
            $t('cs-contact')
          }}</router-link>
        </div>
      </div>
    </div>

    <!-- <div class="backtotop">
      <img src="@/static/images/back-to-top.png" @click="scrollToTop">
    </div> -->
  </div>
</template>

<script>
import axios from 'axios'
import {
  axiosGetGameType,
  captcha,
  axiosLogin,
  axiosRegist,
  me,
  lang,
  GameBalance,
} from '@/api/apiIndex.js'
import userPop from '../../components/olay/userPop.vue'
import infUserPop from '@/components/infigaUserpop.vue'
import register from '../../components/dumanbet/register.vue'
import login from '../../components/dumanbet/login.vue'
import gameType from '../../utils/platType/game'
import TopBar from './../../components/topBar.vue'
import SideBar from '../../components/sideBar.vue'
import { mapState } from 'vuex'

export default {
  components: {
    login,
    register,
    userPop,
    infUserPop,
    TopBar,
    SideBar,
  },
  data() {
    return {
      showPassword3: false,
      showPassword2: false,
      showPassword: false,
      isModalVisible: false,
      dropdownOpen: false,
      showMoney: '0',
      userPopTitle: 'Deposit',
      userPopShow: false,
      activeButton: false,
      siteLogo: '',
      userinfo: '',
      loginShow: false,
      registerShow: false,
      // top2mune: ["电子游戏", "视讯直播"],
      top2mune: ['电子游戏'],
      selectLang: {},
      language: [],
      game1: '',
      game3: '',

      formLabelAlign: {
        name: '',
        password: '',
        site: '63s.online',
        country_code: '',
      },
      loginRules: {
        phone: [
          { required: true, message: this.$t('请输入手机号'), trigger: 'blur' },
        ],
        password: [
          { required: true, message: this.$t('请输入密码'), trigger: 'blur' },
        ],
      },

      registData: {
        phone: '',
        password: '',
        password_confirmation: '',
        country_code: '', // - country code of the phone number, example : +55
        //captcha: ""
        invite_code: '',
      },

      registRules: {
        password: [
          { required: true, message: this.$t('请输入密码'), trigger: 'blur' },
        ],
        password_confirmation: [
          {
            required: true,
            message: this.$t('请再次输入密码'),
            trigger: 'blur',
          },
        ],
        phone: [
          { required: true, message: this.$t('请输入手机号'), trigger: 'blur' },
        ],
        // captcha: [
        //   { required: true, message: this.$t("请输入验证码"), trigger: "blur" }
        // ]
      },
      loginLoading: false,
      validationErrors: {}, // Initialize validation errors
      codeImgObj: {},
      codeIsClick: false,
    }
  },
  computed: {
    ...mapState({
      showModalLogin: (store) => store.topBar.showLoginModal,
      showModalRegister: (store) => store.topBar.showRegisterModal,
    }),
    getCurrentHostName() {
      return location.hostname == 'localhost'
        ? '63s.online'
        : location.hostname
    },
    isCurrentRouteProfile() {
      return this.$route.path === '/profile'
    },
  },
  async created() {
    this.$store.dispatch('getUserInfo')

    if (sessionStorage.getItem('userInfo')) {
      this.userinfo = JSON.parse(sessionStorage.getItem('userInfo'))
      this.refreshUserInfo()
    } else {
      this.refreshUserInfo()
    }
    if (localStorage.getItem('language')) {
      this.selectLang = JSON.parse(localStorage.getItem('language'))
    }
    await this.getGame(1)
    await this.getGame(3)
    await this.fetchSiteData()
    setInterval(() => {
      if (sessionStorage.getItem('token')) {
        this.refreshUserInfo()
      }
    }, 30000)

    this.getCode()
  },
  mounted() {
    // Check if the user is visiting for the first time
    if (!localStorage.getItem('firstVisit')) {
      // Set the flag to mark that the user has visited before
      localStorage.setItem('firstVisit', 'true');

      // Wait 2 seconds before forcing a reload to refresh the page once
      setTimeout(() => {
        location.reload();
      }, 2000);
    }

    if (this.$route.query.r) this.registData.invite_code = this.$route.query.r
    this.isProfileRoute();
  },

  methods: {
    showPasswordFunc() {
      if (!this.showPassword) return (this.showPassword = true)
      return (this.showPassword = false)
    },
    showPasswordFunc2() {
      if (!this.showPassword2) return (this.showPassword2 = true)
      return (this.showPassword2 = false)
    },
    showPasswordFunc3() {
      if (!this.showPassword3) return (this.showPassword3 = true)
      return (this.showPassword3 = false)
    },
    onSelect({ name, iso2, dialCode }) {
      this.registData.country_code = dialCode
    },
    onSelectLogin({ name, iso2, dialCode }) {
      this.formLabelAlign.country_code = dialCode
    },
    showLoginModal() {
      this.$store.commit('setLoginModalStatus', true)
      this.$store.commit('setRegisterModalStatus', false)
    },
    showRegisterModal() {
      this.$store.commit('setLoginModalStatus', false)
      this.$store.commit('setRegisterModalStatus', true)
    },
    closeLoginModal() {
      this.$store.commit('setLoginModalStatus', false)
    },
    closeRegisterModal() {
      this.$store.commit('setRegisterModalStatus', false)
    },
    showModal() {
      this.isModalVisible = true
    },
    hideModal() {
      this.isModalVisible = false
    },
    formatNumber(event) {
      const rawValue = event.target.value.replace(/[^\d\s]/g, '')

      const formattedValue = rawValue.replace(
        /(\d{3})(\d{3})(\d{4})/,
        '$1 $2 $3'
      )
      event.target.value = formattedValue

      this.registData.phone = formattedValue // Fixed assignment

      if (formattedValue.length > 13) {
        this.validationErrors.phone = this.$t('invalid_phone')
        return (isValid = false)
      }
    },
    async fetchSiteData() {
      try {
        const response = await axios.get(
          `https://admin.lotusslots.lol/api/dynamicwebs/getdata?sitename=${this.getCurrentHostName}`
        )
        this.siteLogo = response.data.site_logo
        this.$store.commit('setTelegramLink', response.data.domain)
        this.$store.commit('setPageBackgroundImg', response.data.home_background_image)
        this.language = response.data.supported_language.map((lang) => ({
          icon: lang.language_flag_link,
          option: lang.language_name,
          value: lang.language_code.endsWith('1')
            ? lang.language_code.slice(0, -1).toLowerCase()
            : lang.language_code.toLowerCase(),
        }))
      } catch (error) {
        console.error('Error fetching site data:', error)
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen
    },
    refreshUserInfo() {
      me()
        .then((res) => {
          if (res.code == 200) {
            this.userInfoData = res.data
            if (res.data.money) {
              this.showMoney = res.data.money
            } else {
              this.gameMoney()
            }
          } else {
            // this.$message.error(res.message);
          }
        })
        .catch((err) => {
          if (this.comJs.tokenIsExpire(err.response.data.error)) {
            this.noTOkenData = true
            return
          }
          this.$message.error(this.$t('network-error'))
        })
    },

    // Get the balance in the game
    gameMoney() {
      for (let index = 0; index < gameType.length; index++) {
        GameBalance({
          platType: gameType[index],
        }).then((res) => {
          if (res.code == 200) {
            if (res.data.pg) {
              this.showMoney = res.data.pg
            }
            if (res.data.pp) {
              this.showMoney = res.data.pp
            }
          }
        })
      }
    },

    closeUserPop(item) {
      this.userPopShow = item
    },

    menuShow() {
      if (this.$refs.usermenu.style.display == 'none') {
        this.$refs.usermenu.style.display = 'flex'
      } else {
        this.$refs.usermenu.style.display = 'none'
      }
    },
    closeRegister(item) {
      this.registerShow = item
    },
    closeLogin(item) {
      this.loginShow = item
    },
    registerPop(item) {
      this.registerShow = item
    },
    loginPop(item) {
      this.loginShow = item
    },
    ChangePath(item) {
      if (item == '电子游戏') {
        this.$router.push('/game')
        this.activeButton = true
      }
      if (item == '视讯直播') {
        this.$router.push('/video')
      }
    },
    // Select language
    selectLangShow(item) {
      localStorage.setItem('language', JSON.stringify(item))
      location.reload()
    },
    // Show language options
    selectLanguage() {
      if (this.$refs.selectlang.style.display == 'none') {
        this.$refs.selectlang.style.display = 'block'
        this.$refs.langicon.className = 'el-icon-arrow-up'
      } else {
        this.$refs.selectlang.style.display = 'none'
        this.$refs.langicon.className = 'el-icon-arrow-down'
      }
    },

    // Game first level classification Rendering at the top navigation
    getGame(i) {
      return new Promise((resolve, reject) => {
        let data = { gameType: i }
        axiosGetGameType(data)
          .then((res) => {
            resolve()
            switch (i) {
              case 1:
                this.game1 = res.data.filter((v) => {
                  return v.api_name != 'AB'
                })
                localStorage.setItem('game1', JSON.stringify(res.data))
                break
              case 3:
                this.game3 = res.data.filter((v) => {
                  return (
                    v.api_name != 'PT' &&
                    v.api_name != 'RTG' &&
                    v.api_name != 'JDB' &&
                    v.api_name != 'PG' &&
                    v.api_name != 'IMSLOT' &&
                    v.api_name != 'MV'
                  )
                })
                localStorage.setItem('game3', JSON.stringify(res.data))
                break
            }
          })
          .catch((err) => {
            reject()
            this.$message.error(this.$t('network-error'))
          })
      })
    },

    maxPageLoading(text) {
      this.loading = this.$loading({
        lock: true,
        text: text,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
    },

    // Get Code
    getCode() {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        if (this.codeIsClick) return
        this.codeImgObj = ''
        this.codeIsClick = true
        captcha()
          .then((res) => {
            resolve()
            this.codeIsClick = false
            if (res.code == 200) {
              this.codeImgObj = res.data
              this.isLoading = false
            }
          })
          .catch((err) => {
            reject()
            this.isLoading = false
            this.codeIsClick = false
          })
      })
    },

    // Submit Login
    validateLoginPhone() {
      // Remove all non-digit characters
      const cleanedPhone = this.formLabelAlign.name.replace(/\D/g, '')

      // Update the pattern to match between 6 and 10 digits
      const phonePattern = /^[0-9]{6,10}$/

      // Validate the phone number
      if (!phonePattern.test(cleanedPhone)) {
        this.$set(this.validationErrors, 'name', this.$t('valid-number'))
      } else {
        this.$delete(this.validationErrors, 'name')
      }
    },

    validatePassword() {
      if (this.formLabelAlign.password.length < 6) {
        this.$set(this.validationErrors, 'password', this.$t('pass-error'))
      } else {
        this.$delete(this.validationErrors, 'password')
      }
    },

    subLogin() {
      this.validationErrors = {}

      // Validate fields
      // this.validateLoginPhone();
      this.validatePassword()

      if (Object.keys(this.validationErrors).length === 0) {
        let data = { ...data, ...this.formLabelAlign }
        data.name = this.formLabelAlign.name.replace(/\s+/g, '')
        data.site = this.getCurrentHostName
        this.maxPageLoading(this.$t('正在登录中'))
        if (this.loginLoading) return
        this.loginLoading = true
        axiosLogin(data)
          .then((res) => {
            if (res.code == 200) {
              sessionStorage.setItem('token', JSON.stringify(res.data))
              // 获取登录用户信息
              this.closeLoginModal()
              this.$store.dispatch('getUserInfo')
              this.getUserInfo()
              this.close()
            } else {
              this.loginLoading = false
              this.loading.close()
              this.$message.error(res.data.message)
            }
          })
          .catch((err) => {
            this.loginLoading = false
            this.loading.close()
            // this.getCode();
            this.$message.error(err.response.data.message)
          })
      } else {
        // this.$message.error(this.$t("请修正表单中的错误"));
      }
    },

    // 获取用户信息
    getUserInfo() {
      me()
        .then((res) => {
          this.loginLoading = false
          if (this.loading != '') {
            this.loading.close()
          }

          if (res.code == 200) {
            sessionStorage.setItem('userInfo', JSON.stringify(res.data))
            this.userinfo = true
            this.userInfoData = res.data

            // Avoid redundant navigation
            if (this.$route.path !== '/') {
              this.$router.push('/')
            } else {
              // Optionally, you could trigger some update or refresh logic here if necessary
            }
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((err) => {
          this.loginLoading = false
          if (err.response) {
            console.error('Response data:', err.response.data)
            if (this.comJs.tokenIsExpire(err.response.data.error)) {
              this.noTOkenData = true
              return
            }
            this.$message.error(
              err.response.data.message || this.$t('network-error')
            )
          } else {
            console.error('Network or other error:', err)
            this.$message.error(this.$t('network-error'))
          }
        })
    },

    // Submit Register
    subRegist() {
      // Clear any previous validation messages
      this.validationErrors = {}

      // Perform validation
      let isValid = true
      this.registData.country_code

      // Check for required fields and other custom rules
      for (let field in this.registRules) {
        if (this.registRules[field]) {
          this.registRules[field].forEach((rule) => {
            if (rule.required && !this.registData[field]) {
              this.validationErrors[field] = rule.message
              isValid = false
            }
          })
        }
      }

      // Additional custom validations
      if (this.registData.password && this.registData.password.length < 6) {
        this.validationErrors.password = this.$t('pass-error')
        isValid = false
      }

      if (this.registData.password !== this.registData.password_confirmation) {
        this.validationErrors.password_confirmation = this.$t('valid-pass2')
        isValid = false
      }

      // if (!this.validatePhone(this.registData.phone)) {
      //   this.validationErrors.phone = this.$t("valid-number");
      //   isValid = false;
      // }

      // Proceed with registration if all validations pass
      if (isValid) {
        this.registerUser()
      } else {
        this.$message.error(this.$t('fix-error'))
      }
    },

    validatePhone(phone) {
      // Remove all non-digit characters
      const cleanedPhone = phone.replace(/\D/g, '')

      // Example phone validation: exactly 10 digits
      const phonePattern = /^[0-9]{6,10}$/

      return phonePattern.test(cleanedPhone)
    },

    registerUser() {
      // if ("key" in this.codeImgObj) {
      let data = { ...this.registData }
      let loginData = { ...this.registData }
      loginData.name = data.phone.replace(/\s+/g, '')
      loginData.site = this.getCurrentHostName
      data.phone = data.phone.replace(/\s/g, '')
      // data.key = this.codeImgObj.key;
      data.register_site = `https://${this.getCurrentHostName}`
      data.site = `${this.getCurrentHostName}`
      this.maxPageLoading(this.$t('正在注册中'))
      axiosRegist(data)
        .then((res) => {
          this.loading.close()
          if (res.code == 200 && res.status !== 'fail') {
            setTimeout(() => {
              axiosLogin(loginData)
                .then((res) => {
                  if (res.code == 200) {
                    sessionStorage.setItem('token', JSON.stringify(res.data))
                    // 获取登录用户信息
                    this.getUserInfo()
                    this.$store.dispatch('getUserInfo')
                    this.close()
                    this.this.registData = {
                      phone: '',
                      password: '',
                      password_confirmation: '',
                      country_code: '',
                      invite_code: '',
                    }
                  } else {
                    this.loginLoading = false
                    this.loading.close()
                    this.$message.error(res.data.message)
                    this.$store.dispatch('getUserInfo')
                  }
                })
                .catch((err) => {
                  this.loginLoading = false
                  this.loading.close()
                  this.$message.error(err.response.data.message)
                })
            }, 1000)
            this.close()
            this.$alert(res.message, '', {
              confirmButtonText: this.$t('注册成功'),
            })
            this.loginLoading = true
          } else {
            this.$alert(res.message, '', {
              confirmButtonText: this.$t('确定'),
            })
          }
        })
        .catch((err) => {
          this.loading.close()
          if ('response' in err) {
            this.$alert(err.response.data.message, '', {
              confirmButtonText: this.$t('确定'),
            })
          } else {
            this.$message.success(this.$t('reg-success'))
            this.$store.commit('setRegisterModalStatus', false)
          }
          //this.getCode();
        })
    },
  },
}
</script>

<style lang="less" scoped>
.password-icon {
  position: absolute;
  right: 2%;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  filter: grayscale(100%);
}

.customer-service {
  position: fixed;
  cursor: pointer;
  bottom: 80px;
  right: calc(50% - 290px);
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
}

.modal-pop {
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9;
  justify-content: center;
  align-items: center;
  max-width: 486px;
}

.cs-box {
  width: 96%;
  height: auto;
  left: 0;
  right: 0;
  margin: 0 auto;
  border-radius: 30px;
  background: #c3f9ff;
  border: 1px solid #2f2e2d;
  z-index: 3;
  border-radius: 10px;
  color: #38516a;
  padding: 20px 10px 30px;

  h2 {
    margin-bottom: 0px;
    color: #002b34;

    span {
      color: #1168da;
    }
  }

  .info {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;

    img {
      max-height: 80px;
      background: linear-gradient(110deg, #6adfff 0%, #093774 100%);
      padding: 15px 23px;
      border-radius: 100%;
    }
  }

  .tele {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 25px auto 0;
    gap: 10px;
    background: #002b34;
    padding: 15px;
    border-radius: 10px;
    color: #fff;

    a.btn {
      display: block;
      background: #44c1e9;
      padding: 10px 15px;
      border-radius: 10px;
      color: #fff;
    }
  }
}

.close {
  display: inline-block;
  padding: 0 5px;
  border-radius: 50%;
  cursor: pointer;
  text-decoration: none;
  text-align: right;
  margin-bottom: 10px;
  color: #1168da;
}

.backtotop {
  position: fixed;
  z-index: 3;
  bottom: 15px;
  right: calc(50% - 290px);
  cursor: pointer;

  img {
    width: 50px;
    background: none;
  }

  &:hover img {
    border-radius: 100%;
  }
}

.middle {
  width: 100%;
  padding-bottom: 50px;
  min-height: 90vh;
}

.logout {
  font-family: 'Saira', sans-serif;
  font-weight: 500;
  font-size: 13px;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  border-radius: 5px;
  padding: 10px;

  img {
    width: 25px;
    height: 25px;
    margin-right: 5px;
  }

  i {
    margin-right: 5px;
  }
}

.form-control {
  padding: 0.7rem !important;
  border-top-right-radius: 9px !important;
  border-bottom-right-radius: 9px !important;
}

.footer {
  padding: 10px;
  background-color: #4441cd;

  h2 {
    font-size: 38px;
    font-weight: 800;
    color: #002b34;

    span {
      color: #1168da;
    }
  }

  p {
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    margin: 0 auto;
  }
}

// .footer-menu {
//   position: fixed;
//   bottom: 0;
//   width: 100%;
//   max-width: 610px;
//   background: #007E7E;
//   box-shadow: 0px 1px 0px 0px #ffffff inset;
//   height: auto;
//   border-radius: 55px;
//   background-position: center bottom;
//   display: flex;
//   justify-content: space-between;
//   align-items: flex-end;
//   z-index: 2;
//   pointer-events: none;

//   div.menu {
//     text-align: center;
//     width: 14%;
//     pointer-events: all;

//     img {
//       padding: 7px 15px 0;
//       width: -webkit-fill-available;
//       vertical-align: baseline;
//     }

//     p {
//       // margin-top: -10px;
//       color: #fff;
//     }

//     // &.depositBtn {
//     //   width: 25%;
//     //   padding: 10px 15px;

//     //   img {
//     //     width: 100%;
//     //     // width: max-content;
//     //     transition: transform 0.3s ease;
//     //   }

//     //   &:hover {
//     //     background: none;
//     //     img {
//     //       transform: scale(1.1);
//     //     }
//     //   }
//     // }

//     &:hover {
//       border: 1px solid;
//       border-radius: 100%;
//       background: linear-gradient(180deg, #007E7E 0%, #33ACAC 100%);
//       img {
//           ;
//         }
//     }
//   }
// }
.active-bottom-nav-img {
  width: 60px; 
  margin-top: -3rem;
  padding: 0 0.7rem 2rem 1.4rem;
  @media (max-width: 392px) {
    padding: 0 0.7rem 2rem 1.4rem;
  }
  @media (max-width: 555px) {
    margin-top: -3rem;
    padding: 0 1.2rem 1.9rem 1.1rem;
  }
}
.footer-menu {
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 610px;
  background: #1A2C38;
  height: auto;
  // border-radius: 20px 20px 0 0;
  background-position: center bottom;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  z-index: 0;
  pointer-events: none;
  height: 70px;

  div.menu {
    line-height: 15px;
    text-align: center;
    width: 16.5%;
    pointer-events: all;
    // padding: 14px;
    margin: 5px;

    img {
      // padding: 7px 15px 0;
      // height: 34px;
      width: -webkit-fill-available;
      vertical-align: baseline;
    }

    p {
      margin-top: -10px;
      color: #fff;
    }

    &.active {
      div {
        background: linear-gradient(137.97deg, #01be84 2.34%, #007b9a 97.66%);
      }
    }

    // &.depositBtn {
    //   width: 25%;
    //   padding: 10px 15px;

    //   img {
    //     width: 100%;
    //     // width: max-content;
    //     transition: transform 0.3s ease;
    //   }

    //   &:hover {
    //     background: none;
    //     img {
    //       transform: scale(1.1);
    //     }
    //   }
    // }

    // &:hover {
    //   // background: linear-gradient(180deg, #5b75ff 0%, #1b2975 100%);
    //   background: linear-gradient(137.97deg, #01be84 2.34%, #007b9a 97.66%);
    //   // border-width: 0px, 1px, 0px, 1px;
    //   // border-style: solid;
    //   border-color: #7173e4;
    //   border-radius: 100px;
    // }
  }
}


/* -------  Modal Login ------- */
.modal-content {
  background-color: transparent !important;
}
.loginReg {
  .modal-content {
    background-image: url(../../static/images/loginBgImg.png) !important;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    border: none !important;
    // background-color: transparent;
    width: 90%;
    border: none;
    left: 50%;
    transform: translateX(-50%);
    border: none;
    margin: 50px 0 0;

    label {
      font-size: 14px;
    }

    .btn-login {
      color: #fff;
      font-weight: 800;
      font-family: "Inter", sans-serif;
      font-size: 15px;
      background: linear-gradient(180deg, #E25629 0%, #FF8000 100%);
      padding: 11px 0;
      border-radius: 7px !important;

      &:hover {
        opacity: 0.8;
      }
    }

    .btn-register {
      color: #fff;
      font-weight: 800;
      font-family: "Inter", sans-serif;
      font-size: 15px;
      background: linear-gradient(180deg, #E25629 0%, #FF8000 100%);
      padding: 11px 0;
      border-radius: 7px !important;

      &:hover {
        opacity: 0.8;
      }
    }

    a {
      color: #fff;
      font-family: AvertaStd-ExtraBold;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }

  &.loginModal .modal-header {
    border-radius: 20px 20px 0px 0;
    border: none !important;

    .sign-up {
      position: relative;

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 3px;
        background-color: #0A1644;
        transition: width 0.3s ease-in-out;
        /* transition for smooth effect */
      }

      &:hover:after {
        width: 100%;
        /* fills the border from left to right on hover */
      }
    }

    p {
      font-family: "Inter", sans-serif;
      font-weight: 600;
      font-size: 17px;
      color: #fff;
    }

    .closeModal {
      cursor: pointer;
    }
  }

  &.regModal .modal-content {
    background-image: url(../../static/images/registerBgImg.png) !important;
  }
  &.regModal .modal-header {
    border-radius: 20px 20px 0 0px;
    border: none !important;
    justify-content: space-evenly !important;
    padding-bottom: 0px !important;

    .register {
      position: relative;

      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 3px;
        background-color: #0A1644;
        transition: width 0.3s ease-in-out;
        /* transition for smooth effect */
      }

      &:hover:after {
        width: 100%;
        /* fills the border from left to right on hover */
      }
    }

    .closeModal {
      cursor: pointer;
    }
  }

  // .imgModal {
  //   pointer-events: none;
  //   position: absolute;
  //   z-index: 1;
  //   left: 50%;
  //   top: -25%;
  //   transform: translate(-50%, 0%);

  //   .img-register {
  //     width: 100%;
  //   }
  // }
  .register-container {
    pointer-events: none;
    position: absolute;
    z-index: 1;
    left: 45%;
    top: -35%;
    transform: translate(-50%, 0%);

    .img-register {
      width: 130%;
    }
  }

  .modal-body {
    // border-width: 0 5px 5px 5px;
    // border-style: solid;
    // border-color: #fff;
    // border-radius: 0 0 20px 20px;
    z-index: 2;
    margin: 0 1rem;

    .modal-title {
      font-family: "Inter", sans-serif;
      color: #fff;
      font-weight: 600;
      font-size: 16.5px;
      text-transform: none !important;
      // margin-top: -42px;
      // margin-bottom: 42px;
      // letter-spacing: -1px;
    }

    .form-content {
      padding: 10px 0px;
    }
  }
}
.golden-ring-border {
    padding: 2px 2px !important;
}
@media (max-width: 555px) {
  .golden-ring-border {
    padding: 2px 2px !important;
  }
}

@media (max-width: 540px) {
  .loginReg .modal-content {
    width: 95%;
  }

  .loginReg.regModal .modal-header {
    min-height: 100%;
  }

  .modal-content {
    .register-container {
      top: -40%;

      img {
        width: 100%;
      }
    }
  }

  .footer-menu div.menu.depositBtn {
    padding: 10px 15px 7px;

    img {
      padding: 0;
    }
  }
}

@media (max-width: 485px) {
  .depositBtn {
    img {
      width: -webkit-fill-available !important;
    }
  }

  .customer-service,
  .backtotop {
    right: 10px;
  }

  .imgModal img {
    max-width: 100%;
  }

  .modal-content {
    .register-container {
      top: -40%;
      left: 50%;

      img {
        width: 100%;
      }
    }
  }

  .modal-content {
    .register-container {
      top: -28%;
    }
  }

  .footer-menu div.menu p {
    font-size: 12px;
    margin-top: -5px;
  }
}

@media (max-width: 435px) {
  .loginReg.regModal .modal-header .closeModal {
    height: 45px;
  }

  .imgModal {
    width: 50%;

    img {
      max-width: 100%;
      transform: translateY(7%);
    }
  }

  .modal-content {
    .register-container {
      top: -34%;

      img {
        width: 100%;
      }
    }
  }

  .footer-menu div.menu.depositBtn {
    padding: 10px 15px 7px;

    img {
      padding: 0;
    }
  }
}

@media (max-width: 375px) {
  .loginReg.regModal .modal-header .closeModal {
    height: 45px;
  }

  .imgModal {
    width: 50%;

    img {
      max-width: 100%;
      transform: translateY(15%);
    }
  }

  .modal-content {
    .register-container {
      img {
        width: 100%;
        transform: translateY(10%);
      }
    }
  }

  .footer-menu div.menu.depositBtn {
    padding: 10px 15px 7px;

    img {
      padding: 0;
    }
  }

  .modal-content {
    .register-container {
      top: -30%;
    }
  }

  .form-content {
    padding: 0 !important;
  }
}

@media (max-width: 320px) {
  .imgModal {
    width: 50%;

    img {
      max-width: 100%;
      transform: translateY(25%);
    }
  }

  .modal-content {
    .register-container {
      img {
        width: 100%;
        transform: translateY(15%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/dumanbet/index.vue